import { useEffect, useRef } from 'react';
import { Notifications as Notify } from '@airtm/airtm-ui';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotifications } from 'routes/Layout/Notifications/Notifications';

import formatDistanceToNowShort from 'utils/formatDistanceToNowShort';

// Notification audio
const audio = new window.Audio('/assets/notification.mp3');

const Notifications = function () {
  const { t } = useTranslation('LAYOUT');
  const {
    list,
    counter,
    onNotificationOpening,
    enabledPushNotifications,
    togglePushNotifications,
    markAllRead,
    isWebPushSupported,
  } = useNotifications();
  const { push } = useHistory();

  // Reference to previous notifications counter
  const previousCounter = useRef(0);

  // Play a notifications sound only if they are more than before
  useEffect(() => {
    const pending = previousCounter.current;
    if (counter > pending) {
      const playPromise = audio.play();

      if (playPromise) {
        playPromise.catch((error) => {
          // eslint-disable-next-line no-console
          console.warn('Unable to play notification sound', { message: error.message });
        });
      }
    }
    previousCounter.current = counter;
  }, [counter]);

  return (
    <Notify
      isWebPushSupported={isWebPushSupported}
      arePushNotificationsEnabled={enabledPushNotifications}
      togglePushNotifications={togglePushNotifications}
      onMarkAllAsRead={markAllRead}
      onViewActivity={() => push('/activity/payouts')}
      onClick={onNotificationOpening}
      viewActivityLabel={t('LAYOUT:NOTIFICATION_VIEW_ACTIVITY')}
      arePushNotificationsEnabledLabel={t('LAYOUT:NOTIFICATION_PUSH_NOTIFICATIONS')}
      markAllAsReadLabel={t('LAYOUT:NOTIFICATION_MARK_ALL_READ')}
      emptyLabel={t('LAYOUT:NOTIFICATION_NONE')}
      newLabel={t('STATIC:NEW')}
      notifications={list.slice(0, 5).map((notification) => {
        return {
          ...notification,
          timeAgo: formatDistanceToNowShort(new Date(notification.date)),
          isRead: notification.read,
        };
      })}
    />
  );
};

export default Notifications;
